module.exports = __webpack_public_path__ + "static/media/iron-fold.9640f0d2.jpg";